import StageConfig from './containers/StageConfig';
import requireAuth from '../../../utils/requireAuth';

export const stageConfigRoutes = [
    {
        path: '/technical/planner-tracker/stage-config',
        component: requireAuth(StageConfig),
        key: 'StageConfig',
    },
];
